import { Reducer } from "redux";

import { ValidatePatientInfoResponse } from "../models/Api/PatientInformation";
import { ValidatePatientMbiInfoDispatchType } from "../models/DispatchTypes/PatientInformation";
import { ValidatePatientMbiInfoActionDispatchTypes } from "../constants/PatientInformation";

export const initialState: ValidatePatientInfoResponse = {
  loading: false,
  response: false,
  error: null,
};

const ValidatePatientMbiInfo: Reducer<
  ValidatePatientInfoResponse,
  ValidatePatientMbiInfoDispatchType
> = (state = initialState, action) => {
  switch (action.type) {
    case ValidatePatientMbiInfoActionDispatchTypes.POST_VALIDATE_PATIENT_MBI_INVOKE: {
      return {
        ...state,
        loading: true,
      };
    }
    case ValidatePatientMbiInfoActionDispatchTypes.POST_VALIDATE_PATIENT_MBI_SUCCESS: {
      return {
        ...state,
        response: action.response,
        loading: false,
      };
    }
     case ValidatePatientMbiInfoActionDispatchTypes.POST_VALIDATE_PATIENT_MBI_ERROR: {
      return {
        ...state,
        error: action.error,
        response: initialState.response,
        loading: false,
      };
    }
    case ValidatePatientMbiInfoActionDispatchTypes.POST_VALIDATE_PATIENT_MBI_RESET: {
      return initialState;
    }
  }
  return state;
};

export default ValidatePatientMbiInfo;
